var discountCode = null;

function initializeButton() {
  document.addEventListener('click', function (e) {
    var hasAction = (e.target.dataset && e.target.dataset.action);

    if (e.target.id == 'applyDiscount') {
      applyDiscount(e);
    }

    if (hasAction) {
      if (e.target.dataset.action == 'remove_discount') {
        e.preventDefault();
        removeDiscount();
      }
    }
  });
}

async function removeDiscount() {
  var cart = await getCart();
  
  await submitDiscountToShopify(null);

  setCookie('discount_code', null, -1);

  // Output to the page
  var headerSection = window.sections.instances.find(function (instance) {
    return instance.type && instance.type == 'header-section';
  });

  if (headerSection) {
    headerSection.cartDrawer.buildCartFromJSON(cart, false);
  }
}

async function showDiscountOnCartPage() {
  if (discountCode) {
    var shopDomain = discountValidator.domain;
    var customer = discountValidator.customer;
    var cart = await getCart();
    var discountedCartResponse = await getDiscountedCart(shopDomain, cart, discountCode, customer);

    if (discountedCartResponse.success) {
      var discountedCart = discountedCartResponse.cart;
      var items = discountedCart.items;
      var cartSubtotal = document.querySelector('p.cart_subtotal');

      for (var item of items) {
        var matchingRow = document.querySelector(`.cart__row[data-key="${item.key}"]`);
        var totalPrice = matchingRow.querySelector('.cart__price.item_price');
        var linePrice = matchingRow.querySelector('.cart__price.line_price');
        
        if (totalPrice)
          totalPrice.innerText = Shopify.formatMoney(item.final_price, '${{amount}}');

        if (linePrice)
          linePrice.innerText = Shopify.formatMoney(item.final_line_price, '${{amount}}');
      }

      cartSubtotal.innerText = Shopify.formatMoney(discountedCart.items_subtotal_price, '${{amount}}');
    } else {
      console.error('Error:', discountedCartResponse.message);
    }
  }
}

async function applyDiscount(e) {
  var button = e.target;
  var discountField = button.closest('div').querySelector('input[type="text"]');
  var domain = button.dataset.shop;
  var customer = button.dataset.customer;

  button.classList.add('btn--loading');

  e.preventDefault();
  
  await showDiscountedCart(discountField.value, domain, customer);

  button.classList.remove('btn--loading');
}

function setCookie(cName, cValue, expDays) {
  var date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

async function showDiscountedCart(discount, domain, customer) {
  // Get the cart
  var cart = await getCart();

  try {
    // Calculate the discounts
    var discountedCart = await getDiscountedCart(domain, cart, discount, customer);

    if (discountedCart.success) {
      // Set discount cookie and apply it to checkout
      setCookie('discount_code', discount, 1);
      await submitDiscountToShopify(discount);

      // Output to the page
      var headerSection = window.sections.instances.find(function (instance) {
        return instance.type && instance.type == 'header-section';
      });

      if (headerSection) {
        headerSection.cartDrawer.buildCartFromJSON(discountedCart.cart, false);
      }
    } else {
      console.error('Error getting discounted cart:', discountedCart.message);
    }
  } catch (err) {
    // Abort
    console.error('Error:', err);
  }
}

function submitDiscountToShopify(discount) {
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.onload = function () {
      if (request.readyState == 4) {
        if (request.status >= 200 && request.status < 400) {
          resolve();
        } else {
          reject(`Error: ${request.responseText}`);
        }
      }
    }

    request.onerror = function () {
      reject('Connection error');
    }

    request.ontimeout = function () {
      reject('Timeout')
    }

    request.open('GET', `/discount/${discount}`, true);
    request.send();
  });
}

function getCart() {
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.onload = function () {
      if (request.readyState == 4) {
        if (request.status >= 200 && request.status < 400) {
          var data = JSON.parse(request.responseText);
          resolve(data);
        } else {
          reject(`Error: ${request.responseText}`);
        }
      }
    }

    request.onerror = function () {
      reject('Connection error');
    }

    request.ontimeout = function () {
      reject('Timeout')
    }

    request.open('GET', '/cart.js', true);
    request.send();
  });
}

function getDiscountedCart(shop, cart, discount, customer) {
  return new Promise(function (resolve, reject) {
    var requestBody = {
      store: shop,
      cart: cart,
      discount: discount,
      customer: customer
    };
    var request = new XMLHttpRequest();

    request.onload = function () {
      if (request.readyState == 4) {
        if (request.status >= 200 && request.status < 400) {
          var data = JSON.parse(request.responseText);
          resolve(data);
        } else {
          reject(`Error: ${request.responseText}`);
        }
      }
    }

    request.onerror = function () {
      reject('Connection error');
    }

    request.ontimeout = function () {
      reject('Timeout')
    }

    request.open('POST', 'https://coupons.mobilepixels.us/proxy/validate', true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(requestBody));
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initializeButton();
});

document.addEventListener('discount_applied', function (e) {
  if (e.detail != discountCode) {
    discountCode = e.detail;
    showDiscountedCart(e.detail, window.discountValidator.domain, window.discountValidator.customer);

    var cartForm = document.querySelector('form.cart');

    if (cartForm) {
      showDiscountOnCartPage();
    }
  }
});

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};